import { MessageSquare, Mail, Phone, MapPin, Shield } from "lucide-react";
import { Link } from "react-router-dom";
import logoImage from "@/assets/logo-zavvi.png";

const Footer = () => {
  return (
    <footer id="contato" className="py-12 md:py-16 border-t border-border bg-card/50" role="contentinfo" aria-label="Rodapé do site">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-8 mb-10 md:mb-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-2">
            <img 
              src={logoImage} 
              alt="Zavvi.ai - Plataforma de Gestão de Atendimento ao Cliente" 
              className="h-16 md:h-20 mb-3 md:mb-4 w-auto object-contain" 
              loading="lazy"
            />
            <p className="text-body-text text-xs md:text-sm mb-4 max-w-xs">
              Plataforma híbrida de atendimento multicanal. 
              WhatsApp e Instagram unificados com IA.
            </p>
            
            {/* Company Info */}
            <div className="text-[10px] md:text-xs text-muted-foreground mb-4 space-y-1">
              <p><strong>GF SERVICOS ONLINE</strong></p>
              <p>CNPJ: 55.287.952/0001-2</p>
              <p>Belo Horizonte - MG, Brasil</p>
            </div>

            {/* Social Links */}
            <div className="flex gap-2 md:gap-3">
              <a
                href="https://wa.me/5511936180993"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 md:w-10 h-8 md:h-10 rounded-full bg-muted flex items-center justify-center text-muted-foreground hover:text-cyber-cyan hover:bg-cyber-cyan/10 transition-colors"
                aria-label="Contato via WhatsApp"
              >
                <MessageSquare size={16} className="md:w-[18px] md:h-[18px]" />
              </a>
            </div>
          </div>

          {/* Product */}
          <nav aria-label="Navegação do produto">
            <h4 className="font-display font-bold text-foreground mb-3 md:mb-4 text-sm md:text-base">Produto</h4>
            <ul className="space-y-2 md:space-y-3">
              <li><a href="#recursos" className="text-body-text hover:text-foreground transition-colors text-xs md:text-sm">Recursos</a></li>
              <li><a href="#planos" className="text-body-text hover:text-foreground transition-colors text-xs md:text-sm">Preços</a></li>
              <li><a href="#comparativo" className="text-body-text hover:text-foreground transition-colors text-xs md:text-sm">Comparativo</a></li>
              <li><a href="#casos-de-uso" className="text-body-text hover:text-foreground transition-colors text-xs md:text-sm">Casos de Uso</a></li>
            </ul>
          </nav>

          {/* Resources */}
          <nav aria-label="Navegação de recursos">
            <h4 className="font-display font-bold text-foreground mb-3 md:mb-4 text-sm md:text-base">Recursos</h4>
            <ul className="space-y-2 md:space-y-3">
              <li><a href="#como-funciona" className="text-body-text hover:text-foreground transition-colors text-xs md:text-sm">Como Funciona</a></li>
              <li><a href="/ajuda" className="text-body-text hover:text-foreground transition-colors text-xs md:text-sm">Central de Ajuda</a></li>
              <li><a href="#integracoes" className="text-body-text hover:text-foreground transition-colors text-xs md:text-sm">Integrações</a></li>
              <li><a href="#faq" className="text-body-text hover:text-foreground transition-colors text-xs md:text-sm">FAQ</a></li>
            </ul>
          </nav>

          {/* Contact */}
          <div>
            <h4 className="font-display font-bold text-foreground mb-3 md:mb-4 text-sm md:text-base">Contato</h4>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <a href="mailto:contato@zavvi.ai" className="flex items-center gap-2 text-body-text hover:text-foreground transition-colors text-xs md:text-sm">
                  <Mail size={14} className="md:w-4 md:h-4 text-cyber-cyan flex-shrink-0" />
                  contato@zavvi.ai
                </a>
              </li>
              <li>
                <a href="https://wa.me/5511936180993" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-body-text hover:text-foreground transition-colors text-xs md:text-sm">
                  <Phone size={14} className="md:w-4 md:h-4 text-cyber-cyan flex-shrink-0" />
                  (11) 93618-0993
                </a>
              </li>
              <li className="flex items-center gap-2 text-body-text text-xs md:text-sm">
                <MapPin size={14} className="md:w-4 md:h-4 text-cyber-cyan flex-shrink-0" />
                São Paulo, Brasil
              </li>
            </ul>
          </div>
        </div>

        {/* Badges */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-6 py-6 border-t border-b border-border mb-6">
          <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
            <Shield size={16} className="text-cyber-cyan" />
            <span>SSL Seguro</span>
          </div>
          <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
            <Shield size={16} className="text-electric-purple" />
            <span>LGPD Compliance</span>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4">
          <p className="text-muted-foreground text-xs md:text-sm text-center md:text-left">
            © 2026 Zavvi.ai. Todos os direitos reservados.
          </p>
          <div className="flex gap-4 md:gap-6 text-xs md:text-sm">
            <Link to="/termos" className="text-muted-foreground hover:text-foreground transition-colors">
              Termos de Uso
            </Link>
            <Link to="/privacidade" className="text-muted-foreground hover:text-foreground transition-colors">
              Política de Privacidade
            </Link>
            <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
